<template>
  <div class="tables">
    <div class="tablehead">
      <div class="tableitem">停车场名称</div>
      <div class="tableitem">总车位数</div>
      <div class="tableitem">当前剩余车位</div>
      <div class="tableitem">充电桩总数</div>
      <div class="tableitem">空闲充电桩</div>
    </div>
    <div class="tablelist">
      <vue-loop-scroll direction="up" :speed="120" :index=0 :mouseStop="true">
        <div class="tablelistitem" v-for="(item,index) in list" :key="index">
          <div class="tableitem">{{ item.title }}</div>
          <div class="tableitem">{{ item.num1 }}</div>
          <div class="tableitem">{{ item.num2 }}</div>
          <div class="tableitem">{{ item.num3 }}</div>
          <div class="tableitem">{{ item.num4 }}</div>
        </div>
      </vue-loop-scroll>
    </div>
  </div>
</template>

<script>

export default {
  name: "vtable",
  components: {},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      list: [
          {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '朱雀广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '世茂大厦',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      }, {
        title: '中天广场',
        num1: '3000',
        num2: '300',
        num3: '300',
        num4: '300',
      },]
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.tables {
  position: relative;
  height: 100%;
  width: 100%;
  //overflow-x: scroll;

}

.tablehead {
  width: 100%;
  margin: auto;
  border: 1px solid rgba(1, 69, 102, 1.00);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .tableitem {
    width: 33%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    height: 25px;
    border-right: 1px solid rgba(1, 69, 102, 1.00);
    color: rgba(78, 169, 213, 1.00);

  }

  .tableitem:nth-child(3) {
    border-right: 0;
  }
}

.tablelist {
  width: 100%;
  margin: auto;
  border: 1px solid rgba(1, 69, 102, 1.00);
  border-top: 0;
  position: relative;
  height: calc(100% - 30px);


  //.tablelistitem:nth-child(1) {
  //  border-top: 0;
  //}

  .tablelistitem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    border-top: 1px solid rgba(1, 69, 102, 1.00);

    .tableitem {
      width: 33%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      height: 25px;
      border-right: 1px solid rgba(1, 69, 102, 1.00);
      color: rgba(78, 169, 213, 1.00);
    }

    .tableitem:nth-child(2) {
      color: rgba(225, 114, 60, 1.00);
    }

    .tableitem:nth-child(3) {
      color: rgba(39, 218, 98, 1.00);
    }

    .tableitem:nth-child(4) {
      color: rgba(225, 114, 60, 1.00);
    }

    .tableitem:nth-child(5) {
      color: rgba(39, 218, 98, 1.00);
    }

    .tableitem:last-child {
      border-right: 0;
    }
  }
}

.vue-loop-scroll {
  position: relative;
  height: 100%;
}
</style>
